module.exports = __webpack_public_path__ + "img/pic2.e14e3a02.png";